// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__CfI3F","navLink":"Nav_navLink__+3Mt0","active":"Nav_active__3h2eF","external":"Nav_external__gmmms"};